import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { RowSection } from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/GeneralTab/Utils';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';
import { selectedOrderTypeDetails } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { SimpleTile } from '../Common/SimpleTile';
import { missingField } from 'app/constants';
import { selectOrderDetailsUIView } from '@AMIEWEB/Order/Store/Order.selectors';

const useStyles = makeStyles()(theme => ({
  boxInlineHeadLabelTxt: {
    'font-weight': '600',
    'margin-top': '0px',
    fontSize: '16px',
  },
}));

export interface OrderRequirementsProps {
  isNewOrderCreation: boolean;
  isEditQualification?: boolean;
  orderCreationEdit?: boolean;
  isOpenFromDetailsPage?: boolean;
  handleCloseModal?: ()=>void;
  isOpenFromPreview?: boolean;
}

const OrderRequirements: React.FunctionComponent<OrderRequirementsProps> = (props: OrderRequirementsProps) => {
  const { isNewOrderCreation } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();
  const [fixedRowHeaderWidth, setFixedRowHeaderWidth] = React.useState(0);
  const orderTypeData = useSelector(selectedOrderTypeDetails);
  const orderDetailsUIView = useSelector(selectOrderDetailsUIView);

  const handleMeasureWidth = (width: number) => {
    setFixedRowHeaderWidth(oldWidth => Math.max(oldWidth, width));
  };

  return (
    <Grid container direction="column">
      <RowSection
        header={
          <div className={classes.boxInlineHeadLabelTxt}>
            {t('order.newOrderCreation.tabs.orderTypeDetail.orderType')}
          </div>
        }
        data={``}
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.orderType')}
        data={isNewOrderCreation ? orderTypeData?.orderType : orderDetailsUIView?.orderDetails?.orderType}
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.reason')}
        data={
          isNewOrderCreation ? orderTypeData?.orderReason : orderDetailsUIView.orderDetails?.orderReason ?? missingField
        }
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.region')}
        data={
          isNewOrderCreation
            ? orderTypeData?.region ?? missingField
            : orderDetailsUIView?.orderDetails?.location?.region ?? missingField
        }
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.numberOfPosition')}
        data={
          isNewOrderCreation ? orderTypeData?.positionsAvailable : orderDetailsUIView?.orderDetails?.positionsAvailable
        }
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.maxFilesSent')}
        data={
          isNewOrderCreation
            ? orderTypeData.maxFilesSent
              ? 'Yes'
              : 'No'
            : orderDetailsUIView?.orderDetails.maxFilesSent
            ? 'Yes'
            : 'No'
        }
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      {(isNewOrderCreation ? orderTypeData?.maxFilesSent : orderDetailsUIView?.orderDetails?.maxFilesSent) && (
        <RowSection
          header={t('order.newOrder.reasonForMaxFilesSent')}
          data={
            isNewOrderCreation
              ? orderTypeData.reasonForMaxFilesSent
              : orderDetailsUIView?.orderDetails?.reasonForMaxFilesSent
          }
          handleMeasureWidth={handleMeasureWidth}
          fixedHeaderWidth={fixedRowHeaderWidth}
          useSpecialPadding={true}
        />
      )}
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.hideFacilityDescription')}
        data={
          isNewOrderCreation
            ? orderTypeData.hideFacilityDescription
              ? 'Yes'
              : 'No'
            : orderDetailsUIView?.orderDetails?.hideFacilityDescription
            ? 'Yes'
            : 'No'
        }
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
        useSpecialPadding={true}
      />
      <RowSection
        header={t('order.newOrderCreation.tabs.orderTypeDetail.suppressExternalPosting')}
        data={
          isNewOrderCreation
            ? orderTypeData.suppressExternalPosting
              ? 'Yes'
              : 'No'
            : orderDetailsUIView?.orderDetails?.suppressExternalPosting
            ? 'Yes'
            : 'No'
        }
        handleMeasureWidth={handleMeasureWidth}
        fixedHeaderWidth={fixedRowHeaderWidth}
      />
      {(isNewOrderCreation
        ? orderTypeData?.ssnRequired === true
        : orderDetailsUIView?.orderDetails?.ssnRequired === true) && (
        <SimpleTile
          title={t('order.newOrderCreation.tabs.orderTypeDetail.ssn')}
          data={'R'}
          type="primary"
          tooltipContent={t('order.newOrderCreation.tabs.orderTypeDetail.required')}
        />
      )}
      {(isNewOrderCreation
        ? orderTypeData?.dobRequired === true
        : orderDetailsUIView?.orderDetails?.dobRequired === true) && (
        <SimpleTile
          title={t('order.newOrderCreation.tabs.orderTypeDetail.dob')}
          data={'R'}
          type="primary"
          tooltipContent={t('order.newOrderCreation.tabs.orderTypeDetail.required')}
        />
      )}
    </Grid>
  );
};

export default OrderRequirements;
